(function () {
  var SHOP_LOGIN_SELECTOR = ".customer-login-shop";
  var root = document.querySelector(SHOP_LOGIN_SELECTOR);

  if (!root) return;

  var polling = false;
  var attempts = 0;
  var maxAttempts = 30;
  var timer = null;
  var reloadKey = "tgsShopLoginReloaded";

  function isAccountPageUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      var path = parsed.pathname.replace(/\/+$/, "");

      return path === "/account" || (path.indexOf("/account/") === 0 && path.indexOf("/account/login") !== 0);
    } catch (error) {
      return false;
    }
  }

  function reloadForCustomerState() {
    try {
      if (window.sessionStorage.getItem(reloadKey) === "true") {
        polling = false;
        return;
      }

      window.sessionStorage.setItem(reloadKey, "true");
    } catch (error) {
      // Continue without sessionStorage if the browser blocks it.
    }

    window.location.reload();
  }

  function stopPolling() {
    polling = false;

    if (timer) {
      window.clearTimeout(timer);
      timer = null;
    }
  }

  function checkLoggedIn() {
    attempts += 1;

    return fetch("/account/login?_tgs_shop_auth_check=" + Date.now(), {
      credentials: "same-origin",
      cache: "no-store",
      redirect: "follow"
    })
      .then(function (response) {
        if (isAccountPageUrl(response.url)) {
          reloadForCustomerState();
          return;
        }

        if (polling && attempts < maxAttempts) {
          timer = window.setTimeout(checkLoggedIn, 1000);
        } else if (attempts >= maxAttempts) {
          stopPolling();
        }
      })
      .catch(function () {
        if (polling && attempts < maxAttempts) {
          timer = window.setTimeout(checkLoggedIn, 1000);
        } else if (attempts >= maxAttempts) {
          stopPolling();
        }
      });
  }

  function startPolling() {
    if (polling) return;

    polling = true;
    attempts = 0;

    try {
      window.sessionStorage.removeItem(reloadKey);
    } catch (error) {
      // Continue without sessionStorage if the browser blocks it.
    }

    if (timer) {
      window.clearTimeout(timer);
    }

    timer = window.setTimeout(checkLoggedIn, 1200);
  }

  document.addEventListener(
    "click",
    function (event) {
      if (event.target.closest && event.target.closest(SHOP_LOGIN_SELECTOR)) {
        startPolling();
      }
    },
    true
  );

  window.addEventListener("focus", function () {
    if (polling) {
      checkLoggedIn();
    }
  });

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden && polling) {
      checkLoggedIn();
    }
  });
})();
